import { render, staticRenderFns } from "./ConfirmEmailChange.vue?vue&type=template&id=1997cd68&"
import script from "./ConfirmEmailChange.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmailChange.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEmailChange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VProgressCircular,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1997cd68')) {
      api.createRecord('1997cd68', component.options)
    } else {
      api.reload('1997cd68', component.options)
    }
    module.hot.accept("./ConfirmEmailChange.vue?vue&type=template&id=1997cd68&", function () {
      api.rerender('1997cd68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/ConfirmEmailChange.vue"
export default component.exports